/* ==========================================================================
   Casemira, badges explicatifs de fiche produit      C1, vagues 5 et 6, 2026
   --------------------------------------------------------------------------
   Contrat : brief de la vague 5, point 5 (phase 2 des badges, validée sur le
   principe le 22/08). Chargé par snippets/casemira-badges.liquid, en `defer`,
   avec assets/casemira-badges.css. Aucune bibliothèque.

   CE QUE FAIT CE FICHIER, ET RIEN D'AUTRE
   Chaque badge porte, depuis le serveur, un attribut `data-cm-tip` : une à deux
   phrases factuelles écrites dans le snippet, une clé par badge. Ce fichier
   transforme le badge en bouton d'aide et pose le panneau qui rend la phrase.

   AUCUN TEXTE N'EST ÉCRIT ICI. Si `data-cm-tip` est absent (page en cache
   servie avant la poussée du Liquid, appel du snippet sans métachamp), le badge
   reste exactement ce qu'il était : une icône et un mot, sans bouton et sans
   panneau. C'est la seule dégradation possible, et elle est silencieuse.

   DEUX FORMES, UN SEUL COMPORTEMENT
   - à partir de 750 px : un panneau ancré sous le badge, 280 px de large ;
   - sous 750 px : une petite feuille basse, 40 % de hauteur au plus, avec une
     poignée, qui se ferme au tap dehors et au glissement vers le bas.
   Ouverture au clic, et au survol après 300 ms sur les appareils qui ont un
   vrai pointeur. Fermeture au clic dehors, à Échap, ou au second clic.
   Un seul panneau ouvert à la fois (DESIGN.md, règle Une Surcouche à la Fois).

   VAGUE 6 : le pointillé sous le libellé est retiré (feuille de style), et une
   classe `cm-badge-sheet-open` est posée sur `body` tant qu'une feuille basse
   est ouverte, pour escamoter le lanceur du chat.
   ========================================================================== */
(function () {
  'use strict';

  /* i18n R2b : table lue UNE fois, repli code (CONVENTION.md § 3). Les textes
     des badges eux-memes ne sont pas ici : ils viennent de `data-cm-tip`, pose
     par le Liquid (CONVENTION.md § 4). Seule la pilule Klarna, rendue par un
     bloc « contenu Liquid » du gabarit, ecrit ses phrases dans ce script. */
  var S = (window.FoxTheme && window.FoxTheme.casemira && window.FoxTheme.casemira.fiche) || {};

  function avec(modele, jeton, valeur) {
    return String(modele).split(jeton).join(valeur);
  }

  var SHEET_MQ = '(max-width: 749.98px)';
  /* ★ C1 vague 6 (point 2) : la classe posée sur `body` pendant qu'une feuille
     basse est ouverte. Elle ne sert qu'à une chose, et seulement en mobile :
     escamoter le lanceur du chat, qui est un `position: fixed` du widget
     externe et qui se retrouvait posé SUR la feuille (mesure du 22/08 : le
     lanceur se donne `z-index: 9988`). La correction de profondeur elle-même
     vit dans assets/casemira-pdp-layout.css ; celle-ci est la ceinture, et
     elle est aussi la bonne réponse de dessin : une bulle de discussion qui
     flotte au-dessus d'un voile n'a rien à faire là. */
  var BODY_SHEET = 'cm-badge-sheet-open';
  var HOVER_DELAY = 300; /* ms, demandé par le brief */
  var HOVER_CLOSE_DELAY = 160;
  var DRAG_CLOSE = 60; /* px de glissement vers le bas qui ferment la feuille */

  var uid = 0;
  var open = null; /* la fiche du badge ouvert : { item, btn, panel, home } */
  var veil = null;
  var hoverTimer = null;
  var leaveTimer = null;

  function isSheet() {
    return window.matchMedia(SHEET_MQ).matches;
  }
  function canHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  /* ------------------------------------------------------------------------
     Le voile de la feuille basse
     ------------------------------------------------------------------------
     Un seul pour toute la page, posé sur `body` : c'est lui qui reçoit le tap
     « dehors » sans que le tap atteigne la page derrière. */
  function ensureVeil() {
    if (veil) return veil;
    veil = document.createElement('div');
    /* `no-empty` : le voile est un div vide, et assets/theme.css:1185 masque
       tout `div:empty` sauf ceux qui portent l'une de ses cinq classes de
       secours. C'est la sienne, on ne fabrique pas la notre et on n'ecrit pas
       un `!important` de plus. Mesure du 23/08 : sans elle, le voile faisait
       0 x 0 et la feuille basse s'ouvrait sans assombrir la page. */
    veil.className = 'cm-badges__veil no-empty';
    veil.setAttribute('aria-hidden', 'true');
    veil.addEventListener('click', function () {
      closePanel();
    });
    document.body.appendChild(veil);
    return veil;
  }

  /* ------------------------------------------------------------------------
     Ouvrir / fermer
     ------------------------------------------------------------------------ */
  function closePanel() {
    clearTimeout(hoverTimer);
    clearTimeout(leaveTimer);
    if (!open) return;
    var rec = open;
    open = null;

    rec.panel.classList.remove('is-open', 'is-dragging');
    rec.panel.style.removeProperty('--cm-sheet-drag');
    rec.btn.setAttribute('aria-expanded', 'false');
    if (veil) veil.classList.remove('is-open');
    document.body.classList.remove(BODY_SHEET);

    /* La feuille basse était posée sur `body` : elle rentre chez elle une fois
       l'animation finie, pour que le panneau ancré retrouve son ancrage. */
    if (rec.panel.parentNode !== rec.item) {
      var back = function () {
        if (open && open.panel === rec.panel) return; /* rouverte entre-temps */
        rec.panel.classList.remove('cm-badges__panel--sheet');
        rec.item.appendChild(rec.panel);
      };
      setTimeout(back, 460);
    }
  }

  /* Le panneau ancré ne se retourne jamais : il glisse vers la gauche quand il
     déborderait du bord droit de la fenêtre. On mesure, on ne devine pas. */
  function place(rec) {
    rec.panel.style.removeProperty('--cm-badge-shift');
    var r = rec.panel.getBoundingClientRect();
    var over = r.right - (window.innerWidth - 16);
    if (over > 0) {
      rec.panel.style.setProperty('--cm-badge-shift', -Math.round(over) + 'px');
    }
  }

  function openPanel(rec) {
    if (open && open.panel === rec.panel) return;
    closePanel();
    open = rec;

    if (isSheet()) {
      rec.panel.classList.add('cm-badges__panel--sheet');
      /* Le voile D'ABORD, la feuille ENSUITE : les deux sont au meme palier de
         profondeur (`--z-drawer`), c'est donc l'ordre du document qui tranche,
         et la feuille doit etre au-dessus de son voile. */
      ensureVeil();
      document.body.appendChild(rec.panel);
      /* Deux temps : la feuille doit être posée à 100 % de translation AVANT
         qu'on lui demande de monter, sinon il n'y a pas de mouvement. */
      document.body.classList.add(BODY_SHEET);
      requestAnimationFrame(function () {
        if (open !== rec) return;
        veil.classList.add('is-open');
        rec.panel.classList.add('is-open');
      });
    } else {
      document.body.classList.remove(BODY_SHEET);
      rec.panel.classList.remove('cm-badges__panel--sheet');
      if (rec.panel.parentNode !== rec.item) rec.item.appendChild(rec.panel);
      rec.panel.classList.add('is-open');
      place(rec);
    }
    rec.btn.setAttribute('aria-expanded', 'true');
  }

  function toggle(rec) {
    if (open && open.panel === rec.panel) closePanel();
    else openPanel(rec);
  }

  /* ------------------------------------------------------------------------
     Le glissement vers le bas ferme la feuille
     ------------------------------------------------------------------------ */
  function armDrag(rec) {
    var y0 = null;
    var dy = 0;

    rec.panel.addEventListener(
      'touchstart',
      function (e) {
        if (!rec.panel.classList.contains('cm-badges__panel--sheet')) return;
        /* On ne prend la main que si la feuille est en haut de son défilement :
           sinon le doigt est en train de lire, pas de fermer. */
        if (rec.panel.scrollTop > 0) return;
        y0 = e.touches[0].clientY;
        dy = 0;
      },
      { passive: true }
    );

    rec.panel.addEventListener(
      'touchmove',
      function (e) {
        if (y0 === null) return;
        dy = e.touches[0].clientY - y0;
        if (dy <= 0) return;
        rec.panel.classList.add('is-dragging');
        rec.panel.style.setProperty('--cm-sheet-drag', Math.round(dy) + 'px');
      },
      { passive: true }
    );

    function end() {
      if (y0 === null) return;
      y0 = null;
      rec.panel.classList.remove('is-dragging');
      rec.panel.style.removeProperty('--cm-sheet-drag');
      if (dy > DRAG_CLOSE) closePanel();
      dy = 0;
    }
    rec.panel.addEventListener('touchend', end, { passive: true });
    rec.panel.addEventListener('touchcancel', end, { passive: true });
  }

  /* ------------------------------------------------------------------------
     Poser le bouton et le panneau sur un badge
     ------------------------------------------------------------------------ */
  function enhance(item) {
    if (item.dataset.cmTipDone) return;
    var tip = item.getAttribute('data-cm-tip');
    if (!tip || !tip.trim()) return;
    var labelEl = item.querySelector('.cm-badges__label');
    if (!labelEl) return;
    item.dataset.cmTipDone = '1';

    uid += 1;
    var pid = 'cm-badge-panel-' + uid;

    /* Le bouton enveloppe ce qui est déjà là : on ne réécrit ni l'icône, ni le
       libellé, on les déplace. Aucun texte n'est recomposé en JavaScript. */
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cm-badges__btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', pid);
    while (item.firstChild) btn.appendChild(item.firstChild);
    item.appendChild(btn);

    var panel = document.createElement('div');
    panel.className = 'cm-badges__panel';
    panel.id = pid;

    var grip = document.createElement('span');
    grip.className = 'cm-badges__panel-grip';
    grip.setAttribute('aria-hidden', 'true');

    var title = document.createElement('p');
    title.className = 'cm-badges__panel-title';
    title.textContent = labelEl.textContent.trim();

    var text = document.createElement('p');
    text.className = 'cm-badges__panel-text';
    text.textContent = tip;

    panel.appendChild(grip);
    panel.appendChild(title);
    panel.appendChild(text);
    item.appendChild(panel);

    var rec = { item: item, btn: btn, panel: panel };

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      clearTimeout(hoverTimer);
      toggle(rec);
    });

    /* Survol : seulement là où il y a un vrai pointeur, et après 300 ms.
       Le panneau est un enfant de la cellule : le pointeur qui passe du badge
       au panneau ne quitte donc pas la cellule, et rien ne se ferme. */
    if (canHover()) {
      item.addEventListener('mouseenter', function () {
        if (isSheet()) return;
        clearTimeout(leaveTimer);
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () {
          openPanel(rec);
        }, HOVER_DELAY);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
        clearTimeout(leaveTimer);
        leaveTimer = setTimeout(function () {
          if (open && open.panel === panel) closePanel();
        }, HOVER_CLOSE_DELAY);
      });
    }

    /* Un clic DANS le panneau ne le ferme pas : on peut vouloir sélectionner
       une phrase. */
    panel.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    armDrag(rec);
  }

  /* ======================================================================
     ★ C1 VAGUE 9, point 4 · LA PILULE KLARNA S'EXPLIQUE
     ----------------------------------------------------------------------
     La pilule « Klarna · ou 26,34 € × 3 sans frais » est rendue par un bloc
     « contenu Liquid » du gabarit (templates/product*.json) : on ne la deplace
     pas, on ne la restyle pas, et on n'y touche pas d'un pixel. Le releve du
     22/08, avant : `cursor: auto`, aucun role, aucun `aria-expanded`, rien a
     cliquer. Elle affirme « sans frais » et n'explique ni quand, ni comment.

     Elle devient donc un bouton d'aide, et elle ouvre EXACTEMENT le meme
     panneau que les badges : ancre sous elle a partir de 750 px, feuille basse
     en dessous, meme voile, meme fermeture au tap dehors, a Echap et au
     glissement vers le bas. Rien n'est reecrit : `openPanel`, `closePanel`,
     `place` et `armDrag` sont ceux des badges, appeles avec la pilule pour
     cellule.

     LE MONTANT N'EST PAS RECALCULE. Il est LU dans la pilule elle-meme
     (`#casemira-klarna-installment`, « 26,34 € × 3 »), debarrasse du « × 3 ».
     C'est la seule facon de garantir que le panneau et la pilule ne diront
     jamais deux chiffres differents : l'arrondi au centime superieur, le format
     monetaire et la mise a jour instantanee du format (vague 7) sont deja faits
     la, une fois. Recalculer ici serait une seconde source de verite, donc une
     occasion de se contredire.

     La pilule reste ce qu'elle est : `position: relative` pour ancrer le
     panneau, et `cursor: help`. Ni fond, ni bordure, ni rayon, ni taille de
     texte ne changent (assets/casemira-badges.css, derniere section).
     ====================================================================== */
  var KLARNA_TITLE = S.klarnaTitre || 'Payer en 3 fois sans frais';

  function klarnaAmount() {
    var el = document.getElementById('casemira-klarna-installment');
    if (!el) return '';
    /* « 26,34 € × 3 » -> « 26,34 € ». On coupe au signe de multiplication, le
       seul separateur que le gabarit ecrit. */
    return (el.textContent || '').split(/[×x]/)[0].replace(/\s+/g, ' ').trim();
  }

  function klarnaText() {
    var m = klarnaAmount() || S.klarnaMontantDefaut || 'ce montant';
    return avec(
      S.klarnaDetail || 'Choisissez Klarna à l\u2019étape paiement : 3 mensualités de [montant] prélevées à 30 jours d\u2019intervalle, sans frais ni dossier.',
      '[montant]', m);
  }

  var klarnaRec = null;

  function refreshKlarna() {
    if (!klarnaRec) return;
    var t = klarnaRec.panel.querySelector('.cm-badges__panel-text');
    var want = klarnaText();
    if (t && t.textContent !== want) t.textContent = want;
  }

  function enhanceKlarna() {
    var pill = document.getElementById('casemira-klarna-line');
    if (!pill || pill.dataset.cmTipDone) return;
    /* Sur les fiches couloir, la pilule vit dans le configurateur et porte sa
       propre classe : elle a le meme identifiant, le meme comportement, et le
       meme panneau lui convient. Rien a distinguer. */
    if (!document.getElementById('casemira-klarna-installment')) return;
    pill.dataset.cmTipDone = '1';

    uid += 1;
    var pid = 'cm-klarna-panel-' + uid;

    /* 17/09 · FRANCE : la pilule ne parle plus seulement de Klarna, le titre du
       panneau non plus. Hors de France, `data-cm-pf` n'existe pas et le titre
       reste « Payer en 3 fois sans frais », mot pour mot. */
    var titreAide = (pill.getAttribute('data-cm-pf') === '1' && S.pfTitre) ? S.pfTitre : KLARNA_TITLE;

    pill.setAttribute('role', 'button');
    pill.setAttribute('tabindex', '0');
    pill.setAttribute('aria-expanded', 'false');
    pill.setAttribute('aria-controls', pid);
    pill.setAttribute('aria-label', titreAide);

    var panel = document.createElement('div');
    panel.className = 'cm-badges__panel cm-klarna__panel';
    panel.id = pid;

    var grip = document.createElement('span');
    grip.className = 'cm-badges__panel-grip';
    grip.setAttribute('aria-hidden', 'true');

    var title = document.createElement('p');
    title.className = 'cm-badges__panel-title';
    title.textContent = titreAide;

    var text = document.createElement('p');
    text.className = 'cm-badges__panel-text';
    text.textContent = klarnaText();

    panel.appendChild(grip);
    panel.appendChild(title);
    panel.appendChild(text);

    /* 17/09 · FRANCE : la pilule propose aussi PayPal en 4 fois. Le panneau
       recoit alors un second paragraphe, qui explique l'echeancier PayPal
       comme le premier explique celui de Klarna. L'attribut `data-cm-pf` est
       ecrit par `snippets/casemira-pdp-klarna.liquid`, et UNIQUEMENT quand le
       pays de l'acheteur est la France : partout ailleurs, cette condition est
       fausse et le panneau est exactement celui d'avant. Le paragraphe ne cite
       aucun montant : il n'a donc rien a rafraichir au changement de variante. */
    if (pill.getAttribute('data-cm-pf') === '1' && S.paypalDetail) {
      var textPp = document.createElement('p');
      textPp.className = 'cm-badges__panel-text';
      textPp.textContent = S.paypalDetail;
      panel.appendChild(textPp);
    }

    pill.appendChild(panel);

    klarnaRec = { item: pill, btn: pill, panel: panel };

    pill.addEventListener('click', function (e) {
      /* Un clic DANS le panneau ne rouvre rien : on peut vouloir selectionner
         une phrase. */
      if (e.target !== pill && panel.contains(e.target)) return;
      e.preventDefault();
      e.stopPropagation();
      clearTimeout(hoverTimer);
      refreshKlarna();
      toggle(klarnaRec);
    });

    pill.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      e.preventDefault();
      refreshKlarna();
      toggle(klarnaRec);
    });

    if (canHover()) {
      pill.addEventListener('mouseenter', function () {
        if (isSheet()) return;
        clearTimeout(leaveTimer);
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () {
          refreshKlarna();
          openPanel(klarnaRec);
        }, HOVER_DELAY);
      });
      pill.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
        clearTimeout(leaveTimer);
        leaveTimer = setTimeout(function () {
          if (open && open.panel === panel) closePanel();
        }, HOVER_CLOSE_DELAY);
      });
    }

    panel.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    armDrag(klarnaRec);
  }

  /* Le format change, la mensualite aussi : le panneau suit, dans le meme tour
     d'evenement que le tap (evenement de la vague 7) comme au retour du
     serveur. */
  document.addEventListener('cm:variant:instant', refreshKlarna);
  document.addEventListener('variant:changed', function () {
    refreshKlarna();
    requestAnimationFrame(refreshKlarna);
  });

  function scan() {
    document.querySelectorAll('.cm-badges__item[data-cm-tip]').forEach(enhance);
    enhanceKlarna();
  }

  /* ------------------------------------------------------------------------
     Fermetures globales
     ------------------------------------------------------------------------ */
  document.addEventListener('click', function () {
    if (open) closePanel();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (!open) return;
    var btn = open.btn;
    closePanel();
    try {
      btn.focus();
    } catch (err) {}
  });

  /* Un changement de forme (rotation, redimensionnement) change la nature du
     panneau : on ferme plutôt que de le faire muter sous les yeux. */
  var rz;
  window.addEventListener(
    'resize',
    function () {
      clearTimeout(rz);
      rz = setTimeout(function () {
        if (open) closePanel();
      }, 120);
    },
    { passive: true }
  );

  /* ------------------------------------------------------------------------
     Cycle de vie
     ------------------------------------------------------------------------ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  /* La fiche se re-rend à chaque changement de variante : les badges peuvent
     être remplacés. On rejoue, débouncé, comme casemira-pdp-reskin.js. */
  var host = document.querySelector('.section-main-product') || document.body;
  if (window.MutationObserver && host) {
    var deb;
    new MutationObserver(function () {
      clearTimeout(deb);
      deb = setTimeout(scan, 80);
    }).observe(host, { childList: true, subtree: true });
  }
})();
